import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-my-rewards',
  imports: [],
  templateUrl: './my-rewards.html',
  styleUrl: './my-rewards.scss',
})
export class MyRewards {

  private router = inject(Router);

  accordionReady = true;
  activeAccordion: number | null = null;
  amount: number | null = null;
  currency = 'dollars';
  resort: string | null = 'ribera';

  currencies = [
    { label: 'Dólares', value: 'dollars' },
    { label: 'Soles', value: 'soles' },
  ];

  resorts = [{ label: 'Inresort Ribera del Rio', value: 'ribera' }];

  /* Mock */
  rewards = [
    {
      receivedDate: new Date(),
      revenue: 1500,
      content: [
        {
          service: 'Alojamiento',
          description: 'Departamento estándar vista piscina',
          checkIn: new Date().toLocaleDateString(),
          checkOut: new Date().toLocaleDateString(),
          revenue: 100,
        },
        {
          service: 'Alimentación + Alojamiento',
          description: 'Desayuno + alojamiento',
          checkIn: new Date().toLocaleDateString(),
          checkOut: new Date().toLocaleDateString(),
          revenue: -250,
        },
        {
          service: 'Alojamiento',
          description: 'Almuerzo + alojamiento',
          checkIn: new Date().toLocaleDateString(),
          checkOut: new Date().toLocaleDateString(),
          revenue: -50,
        },
      ],
    },
    {
      receivedDate: new Date(),
      revenue: 1500,
      content: [
        {
          service: 'Alojamiento',
          description: 'Departamento estándar vista piscina',
          checkIn: new Date().toLocaleDateString(),
          checkOut: new Date().toLocaleDateString(),
          revenue: 100,
        },
        {
          service: 'Alimentación + Alojamiento',
          description: 'Desayuno + alojamiento',
          checkIn: new Date().toLocaleDateString(),
          checkOut: new Date().toLocaleDateString(),
          revenue: -250,
        },
        {
          service: 'Alojamiento',
          description: 'Almuerzo + alojamiento',
          checkIn: new Date().toLocaleDateString(),
          checkOut: new Date().toLocaleDateString(),
          revenue: -50,
        },
      ],
    },
  ];

  //Datos Wallet
  walletDetails: any[] = [];
  selectedWalletDetail: any | null = null;

  //TRAER EL BALANCE Y EL DETALLE DE LOS WALLET
  onWalletBalanceLoaded(response: any) {
    const data = response.data;
    this.walletDetails = data.walletDetails ?? [];
    if (this.walletDetails.length) {
      this.selectedWalletDetail = this.walletDetails[0];
      this.resort = this.selectedWalletDetail.portfolio.portfolioId;
    }
  }

  onWalletChange(walletDetail: any) {
    this.selectedWalletDetail = walletDetail;
  }

  get reward(): number {
    return Number((this.amount! * 2).toFixed(2));
  }

  formatRevenue(value: number): string {
    return value >= 0 ? `+ ${value}` : `- ${Math.abs(value)}`;
  }
}
